import React, { useState, useEffect, useRef, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import './ExportButton.scss';

const BdsIcon = 'bds-icon' as any;

export interface ExportButtonProps {
  eventVisible?: string;
  eventAll?: string;
}

export const ExportButton: React.FC<ExportButtonProps> = ({
  eventVisible = 'mfe-sort-export-visible',
  eventAll = 'mfe-sort-export-all',
}) => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);

  const dispatch = useCallback((eventName: string) => {
    window.dispatchEvent(
      new CustomEvent(eventName, { 
        detail: { timestamp: new Date().toISOString() },
      })
    );
    setIsOpen(false);
  }, []);

  useEffect(() => {
    const handleEvents = (event: MouseEvent) => {
      if (containerRef.current && !containerRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleEvents);
    return () => {
      document.removeEventListener('mousedown', handleEvents);
    };
  }, []);

  return (
    <div 
      className={`export-button-container ${isOpen ? 'export-button-container--open' : ''}`} 
      ref={containerRef}
    >
      <button
        type="button"
        className="export-button__trigger"
        onClick={() => setIsOpen((prev) => !prev)}
        aria-haspopup="true"
        aria-expanded={isOpen}
      >
        <BdsIcon name="download" theme="outline" />
        <span>{t('sortBy.submenu.export')}</span>
        <BdsIcon 
          name="arrow-down" 
          theme="outline" 
          className="export-button__arrow" 
        />
      </button>

      {isOpen && (
        <div className="export-button__dropdown">
          <ul className="export-button__list">
            <li className="export-button__item">
              <button
                type="button"
                className="export-button__option"
                onClick={() => dispatch(eventVisible)}
              >
                <span className="export-button__label">
                  {t('sortBy.submenu.exportButton.visible')}
                </span>
              </button>
            </li>
            <li className="export-button__item">
              <button
                type="button"
                className="export-button__option"
                onClick={() => dispatch(eventAll)}
              >
                <span className="export-button__label">
                  {t('sortBy.submenu.exportButton.all')}
                </span>
              </button>
            </li>
          </ul>
        </div>
      )}
    </div>
  );
};